import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, timeout } from 'rxjs/operators';
import { throwError as observableThrowError } from 'rxjs';
import { BillingRequest } from '../model/billing-request';

@Injectable()
export class MajesoPaymentService {
    static CORRELATION_ID = 'CorrelationId';
    static TIMEOUT = 120000;
    private _billingRequest: BillingRequest;

    constructor(private http: HttpClient) {}

    public get billingRequest(): BillingRequest {
        return this._billingRequest;
    }

    doBillingDetermination(requestObject: BillingRequest) {
        this._billingRequest = requestObject;
        const url: string =
            environment.backend + environment.uri.billingdetermination;

        const headers = {};
        headers[MajesoPaymentService.CORRELATION_ID] = new Date()
            .getTime()
            .toString();

        return this.http
            .post<any>(url, requestObject, {
                headers: new HttpHeaders(headers),
            })
            .pipe(
                timeout(MajesoPaymentService.TIMEOUT),
                catchError((error: Response) => {
                    return observableThrowError(error);
                })
            );
    }
}
